import { ComponentProps } from 'react'
import { cn } from '~utils/cn'

import { DialogType, useDialogContext } from './context'

type DialogActionProps = Readonly<ComponentProps<'div'>>
type DialogActionCss = { [key in DialogType]: string }

const DIALOG_ACTION_CSS: DialogActionCss = {
  prompt: 'flex-col-reverse flex-gap-y-2 pt-5 lg:flex-row lg:justify-end lg:pt-6',
  alert: 'justify-end pt-3',
}

const DialogAction = ({ children, className, ...props }: DialogActionProps) => {
  const { type } = useDialogContext()

  return (
    <div {...props} className={cn('flex', DIALOG_ACTION_CSS[type], className)}>
      {children}
    </div>
  )
}

export default DialogAction
